export default __webpack_public_path__ + "static/media/sport-detail.1ec0d3bd.svg";